import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-veteran-children-title']),
    pregnantWithVeteran: yesNoUI({
      title: content['household-veteran-children-pregnant'],
    }),
    childWithVeteran: yesNoUI({
      title: content['household-veteran-children-child-with'],
    }),
  },
  schema: {
    type: 'object',
    properties: {
      pregnantWithVeteran: yesNoSchema,
      childWithVeteran: yesNoSchema,
    },
    required: ['pregnantWithVeteran', 'childWithVeteran'],
  },
};
